module.exports = __webpack_public_path__ + "media/images/home/ic_resend_email-b5fd4503c8516467aab7f63ff12f99b9.svg";